import React from 'react'
import Img from "gatsby-image"

class Gallery extends React.Component {
    constructor(props) {
        super(props)
        console.log(props)
    }
    render() {
        return <div style={{ 
            display: 'flex', 
            flexDirection: 'row', 
            flexWrap: 'wrap', 
            alignItems: 'center',
            justifyContent: 'space-around',
        }}>
            { this.props.images.map(edge => {
                return <Img 
                    style={{ 
                        width: edge.node.childImageSharp.sizes.presentationWidth / 2, 
                        height: edge.node.childImageSharp.sizes.presentationHeight / 2, 
                        maxWidth: '100%',
                        margin: 8,
                    }}
                    key={ edge.node.id }
                    fluid={ edge.node.childImageSharp.fluid }
                /> })
            }
        </div>
    }
}

export default Gallery  
